import useAuthStore from '../auth.store.js';
import { getAuthConfig } from '../config.js';
import { isReactNative, platformRestart } from '../platform.js';
import { signOutCognito } from '../cognito/cognito.helper.js';
import { clearCurrentUser } from '../services/user.service.js';

const signOut = async (options)=>{
    const config = getAuthConfig();
    try {
        await signOutCognito(options);
        useAuthStore.setState({
            isLoggedIn: false
        });
        clearCurrentUser();
        // Platform-specific cache clearing
        if (isReactNative()) {
            try {
                const { NativeModules } = require('react-native');
                const { WebviewCache } = NativeModules;
                await WebviewCache?.clear();
            } catch (error) {
                console.warn('WebviewCache clear failed:', error);
            }
        }
    } catch (error) {
        if (config.onError) {
            config.onError(error, {
                context: 'signOut',
                global: options?.global
            });
        } else {
            console.error('signOut error:', error);
        }
        throw error;
    }
};
const globalSignOutSideEffect = async ()=>{
    await signOut({
        global: true
    });
    platformRestart('Global Sign Out');
};

export { globalSignOutSideEffect, signOut };
//# sourceMappingURL=auth-signout.actions.js.map
